<a (click)="onClick()">
  <app-icon alt="Zurück" className="mobile-header-icon" src="back.svg"></app-icon>
</a>
